<template>
	<div class="relative h-11 w-full">
		<div
			class="bg-fill-secondary absolute top-0 bottom-0 left-1/2 h-11 w-11 -translate-x-1/2 rounded-sm transition-all duration-300"
			:class="{
				'opacity-0': !active
			}"
		></div>
		<CaratDownIcon
			class="text-label-primary absolute -top-3 left-1/2 h-6 w-6 -translate-x-1/2 transition-all duration-300"
			:class="{
				'-top-5 opacity-0': !active
			}"
		/>
		<div
			class="absolute top-0 bottom-0 flex w-fit -translate-x-5.5 items-center gap-2 transition-all"
			:style="{
				left: `calc(50% - ${40 * currentRound}px)`
			}"
		>
			<div
				class="shrink-0 snap-center transition-all"
				v-for="(item, i) in cases"
				:class="{
					'h-8 w-8': currentRound !== i,
					'mx-1 h-9 w-9': currentRound === i
				}"
				:data-snap="i"
			>
				<LazyImage
					:src="caseIcon(item, true)"
					:alt="item"
					class="aspect-square h-full w-full"
				/>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import LazyImage from './LazyImage.vue'
import { caseIcon } from '@/utils/urls'
import CaratDownIcon from '@/assets/icons/carat-down.svg'

defineProps<{
	cases: string[]
	currentRound: number
	active: boolean
}>()
</script>
